import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import InvoiceDesigner from './pages/InvoiceDesigner';
import AdminDashboard from './pages/AdminDashboard';
// Auth removed for MVP
import { CurrencyProvider } from './contexts/CurrencyContext';
import { CompanyProvider } from './contexts/CompanyContext';
// User profile removed for MVP
import { InvoiceProvider } from './contexts/InvoiceContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { CurrencySyncProvider } from './components/CurrencySyncProvider';
import SeoHead from './components/SeoHead';

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      retry: 3,
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
    },
    mutations: {
      retry: 1,
    },
  },
});

function InvoiceDesignerRoute() {
  return (
    <>
      <SeoHead
        title="Free Invoice Generator & PDF Invoice Maker | Invo"
        description="Create professional invoices online, customize invoice templates, add taxes and payment details, and download polished PDF invoices. Free for freelancers, agencies, and small businesses."
        path="/"
      />
      <InvoiceDesigner />
    </>
  );
}

function AdminDashboardRoute() {
  return (
    <>
      <SeoHead
        title="Invo Admin Dashboard"
        description="Internal analytics dashboard for Invo."
        path="/admin"
        robots="noindex,nofollow"
      />
      <AdminDashboard />
    </>
  );
}

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
          <CompanyProvider>
            <CurrencyProvider>
              <CurrencySyncProvider>
                  <InvoiceProvider>
                    <Router>
                  <div className="min-h-screen bg-background text-foreground">
                    <Routes>
                      <Route path="/admin" element={<AdminDashboardRoute />} />
                      <Route path="/" element={<InvoiceDesignerRoute />} />
                      <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                  </div>
                  </Router>
                </InvoiceProvider>
            </CurrencySyncProvider>
          </CurrencyProvider>
        </CompanyProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}

export default App;
